<template>
  <Select v-model="model" clearable @on-change="onChange" filterable transfer>
    <Option v-for="item in channelList" :value="item.channelParam" :key="item.id">{{
        item.id + '-' +item.channelName + ' - ' + $constant.getEnum($constant.tchChannel, item.tchChannel).text
      }}
    </Option>
  </Select>
</template>
<script>
export default {
  name: 'ChannelSelect',
  props: {
    value: {
      type: [Number, String],
    }
  },
  data () {
    return {
      channelList: [],
      model: '',
    }
  },
  methods: {
    onChange (value) {
      this.$emit('input', value)
    },
  },
  mounted: function () {
    let self = this
    self.$http.get('channel/queryall?status=1').then(function (res) {
      if (res && res.data) {
        self.channelList = res.data
        
      } else {
        self.channelList = []
      }
    })
  },
  watch: {
    value (val) {
      this.model = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// ChannelSelect.vue?63691606